module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    attrs: {
      "inline": true,
      "label-position": "top"
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Started",
      "placeholder": "Rent From",
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.equip.rentStarted),
      callback: function($$v) {
        _vm.$set(_vm.equip, "rentStarted", $$v)
      },
      expression: "equip.rentStarted"
    }
  }), _vm._v(" "), _c('select-frequency', {
    attrs: {
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.equip.billPeriod),
      callback: function($$v) {
        _vm.$set(_vm.equip, "billPeriod", $$v)
      },
      expression: "equip.billPeriod"
    }
  }), _vm._v(" "), _c('check-box', {
    attrs: {
      "label": "Invoice?",
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.equip.isInvoiceItem),
      callback: function($$v) {
        _vm.$set(_vm.equip, "isInvoiceItem", $$v)
      },
      expression: "equip.isInvoiceItem"
    }
  }, [_vm._v("Invoice Item")]), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Ref No.",
      "placeholder": "Ref. No.",
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.equip.refNo),
      callback: function($$v) {
        _vm.$set(_vm.equip, "refNo", $$v)
      },
      expression: "equip.refNo"
    }
  }), _vm._v(" "), _c('el-row', [_c('currency-input', {
    attrs: {
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.equip.amount),
      callback: function($$v) {
        _vm.$set(_vm.equip, "amount", $$v)
      },
      expression: "equip.amount"
    }
  }), _vm._v(" "), _c('check-box', {
    attrs: {
      "label": "Taxable",
      "placeholder": "Taxable",
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.isTaxable),
      callback: function($$v) {
        _vm.isTaxable = $$v
      },
      expression: "isTaxable"
    }
  }), _vm._v(" "), (_vm.isTaxable) ? _c('currency-input', {
    attrs: {
      "label": 'Tax = ' + _vm.taxDue(_vm.equip.amount),
      "placeholder": "Tax",
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.equip.tax),
      callback: function($$v) {
        _vm.$set(_vm.equip, "tax", $$v)
      },
      expression: "equip.tax"
    }
  }) : _c('el-form-item', {
    attrs: {
      "label": "Tax"
    }
  }, [(_vm.equip.tax) ? _c('b', [_vm._v(_vm._s(_vm.formatNumber(this.tax)))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Total"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.formatNumber(this.total)))])])], 1), _vm._v(" "), _c('el-row', [_c('h4', [_vm._v("Deposit & Advance Fees")])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "deposit-pane",
    attrs: {
      "sm": 24,
      "md": 24,
      "lg": 16
    }
  }, [_c('el-row', [(_vm.showDepCheck) ? _c('check-box', {
    attrs: {
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.hasDesposit),
      callback: function($$v) {
        _vm.hasDesposit = $$v
      },
      expression: "hasDesposit"
    }
  }, [_vm._v("Has Deposit?")]) : _c('b', {
    staticClass: "text-muted"
  }, [_vm._v("Deposit")])], 1), _vm._v(" "), (_vm.hasDesposit) ? _c('float-input', {
    attrs: {
      "label": "Amount",
      "placeholder": "Amount",
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.equip.deposit),
      callback: function($$v) {
        _vm.$set(_vm.equip, "deposit", $$v)
      },
      expression: "equip.deposit"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasDesposit) ? _c('date-input', {
    attrs: {
      "label": "Deposit Date",
      "placeholder": "Date",
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.equip.depositDate),
      callback: function($$v) {
        _vm.$set(_vm.equip, "depositDate", $$v)
      },
      expression: "equip.depositDate"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasDesposit) ? _c('text-input', {
    attrs: {
      "label": "Deposit Ref",
      "placeholder": "Deposit Ref",
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.equip.depositRef),
      callback: function($$v) {
        _vm.$set(_vm.equip, "depositRef", $$v)
      },
      expression: "equip.depositRef"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "advance-pane",
    attrs: {
      "sm": 24,
      "md": 24,
      "lg": 6
    }
  }, [_c('el-row', [(!_vm.equip.advanceFee) ? _c('check-box', {
    attrs: {
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.isAdvance),
      callback: function($$v) {
        _vm.isAdvance = $$v
      },
      expression: "isAdvance"
    }
  }, [_vm._v("Has Advance Fees?")]) : _c('b', {
    staticClass: "text-muted"
  }, [_vm._v("Advance Fees")])], 1), _vm._v(" "), (_vm.isAdvance) ? _c('float-input', {
    attrs: {
      "label": "Amount",
      "placeholder": "Amount",
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.equip.advanceFee),
      callback: function($$v) {
        _vm.$set(_vm.equip, "advanceFee", $$v)
      },
      expression: "equip.advanceFee"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('h4', [_vm._v("Purchase Cost")])]), _vm._v(" "), _c('el-row', [_c('currency-input', {
    attrs: {
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.equip.purchaseCost),
      callback: function($$v) {
        _vm.$set(_vm.equip, "purchaseCost", $$v)
      },
      expression: "equip.purchaseCost"
    }
  }), _vm._v(" "), _c('currency-input', {
    attrs: {
      "label": 'Tax = ' + _vm.taxDue(_vm.equip.purchaseCost),
      "placeholder": "Tax",
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.equip.purchaseTax),
      callback: function($$v) {
        _vm.$set(_vm.equip, "purchaseTax", $$v)
      },
      expression: "equip.purchaseTax"
    }
  }), _vm._v(" "), (_vm.equip.purchaseCost && _vm.equip.purchaseTax) ? _c('el-form-item', {
    attrs: {
      "label": "Total"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.formatNumber(_vm.equip.purchaseCost + _vm.equip.purchaseTax)))])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a8b8048"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/features/Billable.vue
// module id = 1538
// module chunks = 0